<template>
    <div>
        <!-- This is for errors or messages -->
        <Snackbar
            v-if="showSnackbar"
            :snackbarColor="snackbarColor"
            :snackbarMessage="snackbarMessage"
            @close="closeSnackbar()"
        >
        </Snackbar>
        <!-- END - This is for errors or messages -->

         <div class="content_box">
            <v-card flat class="settings_panel_card">
                <v-toolbar flat dense class="settings_toolbar">
                    <v-toolbar-title class="settings_panel_heading">Configuration</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn depressed icon small v-if="editableButton && showEmptyConfigurationMessage">
                        <v-icon :class="editConfigStatus?'enable':'disabled'" @click="editConfiguration()">create</v-icon>
                    </v-btn>
                    <!-- Import and Export buttons -->
                    <span v-if="!importedFileName && isSuperAdmin">
                        <v-btn depressed icon small class="mx-2">
                            <label>
                                <v-icon flat class="mx-2" title="Import">system_update_alt</v-icon>
                                <input type="file" id="file" ref="file" accept="application/json" v-bind="handleFile"  v-on:change="handleFileUpload();"  onclick="this.value=null;"/>
                            </label>
                        </v-btn>
                        <v-btn depressed icon small @click="exportAppConfigurationFile()" class="mr-2">
                            <v-icon flat class="mx-2" title="Export">open_in_browser</v-icon>
                        </v-btn>
                    </span>
                    <!-- END - Import and Export buttons -->
                    <v-btn color="#736B63" dark small depressed @click="openPopUPLinkIsClicked('advance')" v-if="isSuperAdmin">
                        advance editor
                    </v-btn>
                </v-toolbar>
                <!-- config panel -->
                <div class="apps_config_div">
                    <v-layout wrap v-show="showEmptyConfigurationMessage">
                        <v-flex xs2 class="ml-4 my-3 grey--text">
                            <b>URL</b>
                        </v-flex>
                        <v-flex xs8 class="ml-4 my-3">
                            <span v-if="isEditable">
                                <input type="url" v-model="editableCongiguration.url" class="editableInput" :class="validateURLStatus == null ?'':validateURLStatus ? 'enable':'disable'"/>
                            </span>
                            <span v-else>
                                <span class="configURL">{{tablesConfiguration.callback}}</span>
                            </span>
                        </v-flex>
                        <v-flex xs2 class="ml-4 my-3 grey--text">
                            <b>Callback Header</b>
                        </v-flex>
                        <v-flex xs9>
                            <div class="apps_config_table_div">
                                <table class="apps_config_component_table">
                                    <thead>
                                        <tr v-if="tablesConfiguration.headers != ''">
                                            <th>Key</th>
                                            <th>Value</th>
                                            <th v-if="isEditable">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(key,value,index) in tablesConfiguration.headers" :key="key">
                                            <td>
                                                <v-icon color="purple">vpn_key</v-icon>&nbsp;
                                                {{value}}
                                            </td>
                                            <td>
                                                {{key}}
                                            </td>
                                            <td v-if="isEditable"><i class="material-icons deleteHeader"  @click="deleteHeader(index,key,value)">delete</i></td>
                                        </tr>
                                        <tr v-if="isEditable">
                                            <td>
                                                <input type="text" v-model="callbackHeaderValue" class="inputcallbackheader" title="key required" required placeholder="key"/>
                                            </td>
                                            <td>
                                                <input type="text" v-model="callbackHeaderName" class="inputcallbackheader" title="Value required" required placeholder="value"/>
                                            </td>
                                            <td>
                                                <v-layout row wrap id="callbackHeaderActions">
                                                    <v-flex xs3 class="mt-2">
                                                        <v-icon color="green" @click="saveCallbackHeader()" :class="callbackHeaderValid && callbackHeaderNameValid ?'enable':'disabled'" title="add">check_circle_outline</v-icon>
                                                    </v-flex>
                                                    <v-flex xs3 class="mt-2">
                                                        <v-icon color="red" @click="closeCallbackHeader()" title="clear content">highlight_off</v-icon>
                                                    </v-flex>
                                                </v-layout>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </v-flex>
                        <v-flex xs2 class="ml-4 my-4 grey--text">
                            <b>Certificate</b>
                        </v-flex>
                        <v-flex xs8 class="ml-4 my-4">
                            <span v-if="isEditable">
                                <textarea class="certificateConfiguration" v-model="editableCongiguration.certificate"></textarea>
                            </span>
                            <span v-else>
                                <pre class="certificateInConfiguration">{{tablesConfiguration.certificate}}</pre>
                            </span>
                        </v-flex>
                    </v-layout>
                    <div v-show="!showEmptyConfigurationMessage">
                        <span class="empty_configuration_style">No Configuration Options Available For This Type Of Token</span>
                    </div>
                </div>
                <v-layout row wrap v-if="isEditable">
                        <v-btn color="#736B63" dark small depressed class="ml-4 mb-4" id="configurationSaveBtn" @click="saveEditedChanges('notification')">save</v-btn>
                        <v-btn color="#736B63" dark small depressed class="ml-4 mb-4" id="cancelEditedConfigurationBtn" @click="cancelEditedConfiguration()">cancel</v-btn>
                </v-layout>
                <!-- config panel end -->
                <!-- dialog for ImportConfiguration -->
                <section>
                    <v-dialog max-width="500" scrollable persistent v-model="updateConfigurationFile">
                            <v-card class="import-config-popup" id="importPopup">
                                <v-card-title>
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                            <span class="headline indigo--text">
                                                <v-icon medium>info_outline</v-icon> Import File
                                            </span>
                                        </v-flex>
                                    </v-layout>
                                </v-card-title>
                                <v-card-text>
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                            <span v-if="newAppType" class="checkbox_icon" @click="appChange = !appChange">
                                                <v-icon>{{appChange ? 'check_box' : 'check_box_outline_blank' }}</v-icon>
                                                Update Token Type to {{newAppType}}
                                            </span>
                                            <br><br>
                                            <span v-if="servicesList.length>0" class="checkbox_icon" @click="servicesChange = !servicesChange">
                                                <v-icon>{{servicesChange ? 'check_box' : 'check_box_outline_blank' }}</v-icon>
                                                Remove services not present in the new configuration
                                            </span>
                                            <br>
                                            <span v-for="services in servicesList" :key="services">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*{{services}}<br></span>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn depressed color="grey lighten-3" id="cancelImportBtn" @click="updateConfigurationFile = false">cancel</v-btn>
                                    <v-btn depressed color="grey lighten-3" title="save" id="importBtn" @click="importAppConfigurationFile(),updateConfigurationFile = false">Import</v-btn>
                                </v-card-actions>
                            </v-card>
                    </v-dialog>
                </section>
                <!-- END- ImportConfiguration PopUp -->
                <!-- advanced editor -->
                <section>
                    <div class="show-info-background" v-show="showConfig"></div>
                    <v-dialog width="80%" class="show-info-popup show-info-popup-config" v-model="showConfig" persistent>
                        <v-card height="38rem">
                            <v-toolbar flat dense color="indigo lighten-1" dark>
                                <v-icon>build</v-icon>
                                <v-toolbar-title>Advanced editor - {{displayPanelName}}</v-toolbar-title>&nbsp;
                                <v-spacer></v-spacer>
                                <div :class="gotAPIResponse ? '' :'disabled'">
                                    <v-icon flat class="mx-2" id="editConfiguration" @click="editConfig()" title="Edit Configuration" v-show="!showPanelForServicesAction && !editInPopupConfig && !disableEditButton">
                                        create
                                    </v-icon>
                                    <v-icon flat class="mx-2" id="openConfigurations" @click="backToConfiguration()" title="Configuration Settings" v-show="showPanelForServicesAction">
                                        settings
                                    </v-icon>
                                    <v-icon flat class="mx-2" title="Add service to app" id="services" v-show="!showPanelForServicesAction" @click="enableServicesForApp()">
                                        add
                                    </v-icon>
                                    <v-icon flat class="mx-2" id="closeAdvancedEditor" @click="closeConfig()" title="Close Advanced Editor">
                                        clear
                                    </v-icon>
                                </div>
                            </v-toolbar>
                            <!-- config panel -->
                            <div class="advancedEditorBody" v-if="!showPanelForServicesAction">
                                <v-layout row wrap>
                                    <v-flex xs1 class="mt-3">
                                        <span class="advanced_editor_config_heading">Configuration:</span>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-select
                                            id="servicesDropdown"
                                            solo
                                            :items="availableConfig"
                                            v-model="selectedServiceName"
                                            @change="openPopUPLinkIsClicked()"
                                            class="mt-1 ml-4">
                                        </v-select>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 lg12>
                                        <div class="btn-group configButton" v-for="(item,index) in listOfConfigurationKeys" :key="index">
                                            <button class="buttonGroupInConfiguration" :class="selectedIndex == index ?'active':'' " id="configurationTypes" @click="showConfigurationOfItem(item,index)">{{item}}</button>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 lg12>
                                        <span v-if="editInPopupConfig">
                                            <textarea v-if="editInPopupConfig" id="configurationInfo" class="text_area" v-model="editConfigInPopupTrue.edited"></textarea>
                                        </span>
                                        <span v-else>
                                            <pre class="text_area">{{configResponse}}</pre>
                                        </span>
                                    </v-flex>
                                </v-layout>
                            </div>
                            <!-- config panel ends -->
                            <!-- service panel -->
                            <div class="service_panel_body" v-if="showPanelForServicesAction">
                                <v-layout row wrap class="service_panel_layout">
                                    <v-flex xs12 sm12 md12 lg12 class="mt-3 mr-1">
                                        <!-- body section begins for normal services -->
                                        <div :class="showFailedListOfServices ? 'servicelist_config_body_panel_2' : 'servicelist_config_body'">
                                            <div class="totalappsList_userpage_body">
                                                <span class="displayList_userpage_heading">List of Services</span>
                                                <select size="30" id="totalList" :class="showFailedListOfServices ? 'servicelist_minimized_class' : 'servicesListselecttag'">
                                                    <option v-for="item1 in notEnabledServices" :key="item1.id">{{item1}}</option>
                                                </select>
                                            </div>
                                            <div class="buttonsappslist_userpage_body">
                                                <div class="shifticonsforList_userpage" :class="gotAPIResponse ? '' : 'disabled'">
                                                    <i class="material-icons" id="enableService" @click="addServiceToSelectedList()">arrow_forward</i><br>
                                                    <i class="material-icons" id="disableService" @click="removeServiceFromSelectedList()">arrow_back</i>
                                                </div>
                                            </div>
                                            <div class="selectedAppsList_userpage_body">
                                                <span class="displayList_userpage_heading">Enabled services</span>
                                                <select size="30" id="selectedList" :class="showFailedListOfServices ? 'servicelist_minimized_class' : 'servicesListselecttag'">
                                                    <option v-for="item2 in enabledServices" :key="item2.id">{{item2}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 lg12 v-if="showFailurePanel">
                                        <div class="failed_services" @click="showFailedList()">
                                            <span>Failed to enable/disable services</span>
                                            <i class="material-icons failure_droparrow" v-text="showFailedListOfServices ? 'keyboard_arrow_down':'keyboard_arrow_up'" :class="showFailedListOfServices ? 'minimizefailedclass' : 'maximizefailedclass'"></i>
                                        </div>
                                        <!-- header section ends -->
                                        <!-- failure body section -->
                                        <div class="service_panel_body" v-if="showFailedListOfServices">
                                            <div :class="showFailedListOfServices ? 'servicelist_config_body_panel_2' : 'servicelist_config_body'">
                                                <div class="totalappsList_userpage_body">
                                                    <span class="displayList_userpage_heading">List of Failed Services</span>
                                                    <select size="30" id="totalFailedList" class="servicesListselecttag" :class="showFailedListOfServices ? 'servicelist_minimized_class' : 'servicesListselecttag'">
                                                        <option v-for="item1 in failureList1" :key="item1.id">{{item1}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- failure body section ends -->
                                    </v-flex>
                                </v-layout>
                            </div>
                            <!-- services panel end -->
                            <v-divider></v-divider>
                            <div v-show="(!showPanelForServicesAction && editInPopupConfig) || showPanelForServicesAction" :class="gotAPIResponse? '' : 'disabled'">
                                <v-btn small dark color="deep-purple darken-3" :class="disableSaveButton?'disabled' : ''" id="saveBtn" @click="(!showPanelForServicesAction && editInPopupConfig) ? saveEditedChanges('other'):saveSelectedServicesList('save')">
                                    Save
                                </v-btn>
                                <v-btn small dark color="deep-purple darken-3" id="cancelBtn" @click="(!showPanelForServicesAction && editInPopupConfig) ? cancelPOPupEdit():saveSelectedServicesList('cancel')">
                                    Cancel
                                </v-btn>
                                <span v-show="showErrorMessage" class="error_message">{{errorMessage}} </span>
                            </div>
                        </v-card>
                    </v-dialog>
                </section>
            </v-card>
        </div>
        <confirmationPopupVue
            v-if="importFile"
            :confirmationTitle="'Import File'"
            :confirmationText ="'import file'"
            :name ="showSelectedFile"
            @action="checkDifferentApptypes()"
            @close="cancelFileUpload()">
        </confirmationPopupVue>
    </div>
</template>
<script>
import Vue from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import confirmationPopupVue from '../../../common/components/confirmationPopup';
import Snackbar from "../../../common/components/snackbar"
import {hideLoadIcon,showLoadIcon} from '../../../common/assets/utils/load.js';

export default {
    name:'configuration',
    props: {
        apps: {
            type: Array,
            default: null
        },
        apptoken:{
            type:String,
            default:null
        },
        show_notification_configuration:{
            type:Boolean,
            default:null
        },
        nodeValue:{
            type: String
        }
    },
    data(){
        return{
            // isSuperAdmin:false,
            showEmptyConfigurationMessage : false,
            isEditable : true,
            editableButton:true,
            editConfigStatus:true,
            availableConfig:[],
            tablesConfiguration:[],
            showSnackbar: false,
            snackbarColor: null,
            snackbarMessage: null,
            importedFileName:false,
            handleFile:'',
            importFile: false,
            showSelectedFile:'',
            updateConfigurationFile: false,
            newAppType : null,
            appChange: false,
            servicesList : [],
            servicesChange: false,
            failedListOfConfigurationKeys:[],
            callbackHeaderValue:'',
            callbackHeaderName:'',
            callbackHeaderValid:'',
            callbackHeaderNameValid:'',
            editedURL: '',
            editableCongiguration : {},
            showConfig:'',
            editInPopupConfig:false,
            listOfConfigurationKeys : [],
            notEnabledServices:[],
            enabledServices:[],
            configResponse:{},
            showErrorMessage:false,
            validateURLStatus:null,
            counter:0,
            displayPanelName:'configuration',
            showPanelForServicesAction:false,
            showFailedListOfServices:false,
            showFailurePanel : false,
            selectedServiceName : 'global',
            selectedIndex : -1,
            gotAPIResponse : false,
            disableSaveButton : false,
            disableEditButton : false,
            storeHeadersInConfig : {},
            hide:null,
            errorMessage: null,
        }
    },
    components:{
        confirmationPopupVue,
        Snackbar,
    },
    mounted(){
        this.configurationAPI(this.apptoken);
        this.showEmptyConfigurationMessage = this.show_notification_configuration;
    },
    watch:{
        callbackHeaderValue(){
           var reg_val = /^\S*$/;
            if(this.callbackHeaderValue.length > 1){
                if(reg_val.test(this.callbackHeaderValue)){
                    this.callbackHeaderNameValid = true;
                }
                else{
                    this.callbackHeaderNameValid = false;
                }
            }
            else{
                this.callbackHeaderNameValid = null;
            }
        },
        callbackHeaderName(){
            var reg_name = /[0-9a-zA-Z]/;
            if(this.callbackHeaderName.length > 1){
                if(reg_name.test(this.callbackHeaderName)){
                    this.callbackHeaderValid = true;
                }
                else{
                    this.callbackHeaderValid = false;
                }
            }
            else{
                this.callbackHeaderValid = null;
            }
        },
        editedURL(){
            this.validateURL();
        },
        apptoken(){
            var self = this;
            self.configurationAPI(self.apptoken);
        },
        show_notification_configuration(){
            this.showEmptyConfigurationMessage = this.show_notification_configuration;
            this.configurationAPI(this.apptoken);
        }
    },
    computed: {
        ...mapState({
            // appServicesEnableDisable: state => state.appsDetails.configuration.advancedConfiguration,
            isSuperAdmin: state => state.loginDetails.loggedInUserInformation['is_superadmin'],
        })
    },
    methods:{
        // Functions to display snackbar for success/error messages
        displaySnackbar(color,message){
            var self = this;
            self.showSnackbar = false;
            setTimeout(function(){
                self.showSnackbar = true;
            },100)
            self.snackbarColor = color;
            self.snackbarMessage = message;
        },
        closeSnackbar(){
            var self = this;
            self.showSnackbar = false;
            self.snackbarColor = null;
            self.snackbarMessage = null;
        },
        configurationAPI(tokens,val){
            var self = this;
            self.isEditable = false;
            self.editableButton = true;
            self.editConfigStatus = true;
            self.availableConfig = [];
            self.tokenInConfiguration = tokens;
            showLoadIcon();
            this.$loading(true);
            Vue.http.get('/configuration/',{
                params:{
                    'apptoken' : self.tokenInConfiguration,
                    'node':self.nodeValue
                }
            })
            .then((response)=>{
                try{
                    self.configurationResponse = response.data;
                    if(Object.keys(response.data).length != 0)
                        self.tablesConfiguration = response.data.notification.notificationConfiguration;
                    }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
            });
        },
        editConfiguration(){
            var self = this;
            self.editableButton = false;
            self.isEditable = true;
            self.callbackHeaderValue = '';
            self.editableCongiguration={
                url : self.tablesConfiguration.callback,
                certificate : self.tablesConfiguration.certificate
            }
        },
        handleFileUpload() {
            var self = this;
            self.handleFile = self.$refs.file.files[0];
            if(self.handleFile.type == 'application/json'){
                self.showSelectedFile = self.handleFile.name;
                self.importedFileName = true;
                self.importFile = true;
            }
            else{
                alert('Wrong file extension! Please enter a valid json file.ex:sample.json');
                self.handleFile = '';
            }
        },
        checkDifferentApptypes(){
            var self = this;
            self.importedFileName = false;
            let formData = new FormData();
                formData.append('config_file', self.handleFile);
                formData.append('json', JSON.stringify({ 'apptoken': self.apptoken,
                    'node':self.nodeValue
                }));
            showLoadIcon();
            this.$loading(true);
            Vue.http.post('/check_apptypes/',formData)
            .then((res)=>{
                try{
                    if(res.data.body.different_appTypes && res.data.body.services_list.length>0){
                    self.newAppType = res.data.body.newAppType;
                    self.servicesList = res.data.body.services_list;
                    self.updateConfigurationFile = true;
                    }
                    else if(res.data.body.different_appTypes){
                        self.newAppType = res.data.body.newAppType;
                        self.updateConfigurationFile = true;
                    }
                    else if(res.data.body.services_list.length>0){
                        self.servicesList = res.data.body.services_list;
                        self.updateConfigurationFile = true;
                    }
                    else{
                        self.importAppConfigurationFile();
                    }
                    self.importFile = false;
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error)=>{
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
            })
        },
        cancelFileUpload(){
            var self = this;
            self.showSelectedFile = '';
            self.importFile = false;
            self.importedFileName = false;
        },
        importAppConfigurationFile(){
            var self = this;
            self.importedFileName = false;
            let formData = new FormData();
                formData.append('config_file', self.handleFile);
                formData.append('json', JSON.stringify({ 'apptoken': self.apptoken,
                    'action':'import',
                    'app_change':self.appChange,
                    'services_change':self.servicesChange,
                    'services_list':self.servicesList,
                    'node':self.nodeValue
                }));
            showLoadIcon();
            this.$loading(true);
            Vue.http.post('/appconfig/import/',formData)
            .then((res)=>{
                try{
                    if(res.data.failed_configurations.length > 0){
                        self.displaySnackbar('error-banner','Failed to Import File');
                        self.failedListOfConfigurationKeys = res.data.failed_configurations;
                    }
                    else{
                        self.displaySnackbar('success-banner','File Imported Successfully');
                    }
                    self.resetData();
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error)=>{
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
            })
        },
        resetData(){
            var self = this;
            self.$parent.getApps();
            self.updateConfigurationFile = false;
            self.appChange = false;
            self.servicesChange = false;
            self.newAppType = null;
            self.servicesList = [];
        },
        exportAppConfigurationFile(){
            var self = this;
            showLoadIcon();
            this.$loading(true);
            Vue.http.get('/appconfig/export/',{
                params:{
                    'apptoken' : self.apptoken,
                    'node':self.nodeValue
                }
            })
            .then((res)=>{
                try{
                    let dataStr = JSON.stringify(res.data.configuration,undefined,8);
                    let dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
                    let exportFileDefaultName = 'configuration_file.json';
                    let linkElement = document.createElement('a');
                    linkElement.setAttribute('href', dataUri);
                    linkElement.setAttribute('download', exportFileDefaultName);
                    document.body.appendChild(linkElement); // required for firefox
                    linkElement.click();
                    linkElement.remove();
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error)=>{
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
            })
        },
        openPopUPLinkIsClicked(val){
            var self = this;
            self.availableConfig = [];
            self.showConfig = true;
            self.editInPopupConfig = false;
            self.listOfConfigurationKeys = [];
            self.gotAPIResponse = false;
            showLoadIcon();
            this.$loading(true);
            var time =0;
            if(self.selectedServiceName == "notification"){
                    time =1000;
            }
            setTimeout(()=>{
            Vue.http.get('/advanced_configuration/',{
                params:{
                    'apptoken' : self.apptoken,
                    'node':self.nodeValue,
                    'service_name':self.selectedServiceName
                }
            })
            .then((response)=>{
                try{
                    self.gotAPIResponse = true;
                    self.configurationResponse = response.data;
                    if(val == 'advance'){
                        self.configResponse = self.configurationResponse['global'];
                        self.listOfConfigurationKeys = [];
                    }
                    self.availableConfig = self.configurationResponse.config_services;
                    var notificationcounter = 0;
                    for(var item in self.configurationResponse){
                        if(item == 'notification'){
                            notificationcounter++;
                        }
                    }
                    if(notificationcounter == 1){
                        self.tablesConfiguration = response.data.notification.notificationConfiguration;
                        self.editConfigStatus = true;
                    }
                    if(notificationcounter < 1){
                        // self.showEmptyConfigurationMessage = true;
                        self.editConfigStatus = false;
                    }
                    self.showConfiguration();
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                //console.log("api failed with error:" +error)
                self.showErrorMessage = true;
                self.errorMessage = error.data && error.data.message ? error.data.message : 'Invalid Details/Configuration';
                self.gotAPIResponse = true;
                setTimeout(function(){
                    self.showErrorMessage = false;
                },2000);
            });
            }, time)
        },
        showConfiguration(){
            var self = this;
            self.editInPopupConfig = false;
            self.configResponse = '';
            self.selectedIndex = -1;
            self.listOfConfigurationKeys = [];
            if(Object.keys(self.configurationResponse[self.selectedServiceName]).length <= 0){
                self.disableEditButton = true;
                self.configResponse = "No Configuration available";
            }
            else if(self.selectedServiceName == 'global'){
                self.configResponse = self.configurationResponse[self.selectedServiceName];
                self.configTypePopup = 'global';
                self.configServiceName = 'global';
                self.disableEditButton = false;
            }
            else{
                self.counter++;
                for(var item in self.configurationResponse[self.selectedServiceName]){
                    if(self.configurationResponse[self.selectedServiceName].hasOwnProperty(item)){
                        self.listOfConfigurationKeys.push(item);
                    }
                }
                self.configResponse = self.configurationResponse[self.selectedServiceName][self.listOfConfigurationKeys[0]];
                self.disableEditButton = false;
            }
            self.configTypePopup = self.listOfConfigurationKeys[0];
            self.configServiceName = self.selectedServiceName;
            self.selectedIndex = 0;
            self.showConfig = true;
        },
        showConfigurationOfItem(item,index){
            var self = this;
            self.selectedIndex = index;
            self.editInPopupConfig = false;
            self.configServiceName = self.selectedServiceName ;
            var a = self.configServiceName;
            self.configTypePopup = item;
            var b = self.configTypePopup;
            self.configResponse = self.configurationResponse[a][b];
        },
        validateURL(){
            var urlSpecific = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/;
            this.validateURLStatus = urlSpecific.test(this.editedURL);
        },
        deleteHeader(index,key,value){
            var self = this;
            delete self.tablesConfiguration.headers[value];
        },
        saveCallbackHeader(){
            var self = this;
            if(Object.keys(self.storeHeadersInConfig).length == 0){
                self.storeHeadersInConfig = {
                    [self.callbackHeaderValue] : self.callbackHeaderName.trim()
                }
            }
            else{
                self.storeHeadersInConfig[self.callbackHeaderValue] = self.callbackHeaderName.trim();
            }
            self.tablesConfiguration.headers = self.tablesConfiguration.headers != undefined ? Object.assign(self.tablesConfiguration.headers , self.storeHeadersInConfig) : self.storeHeadersInConfig;
            self.callbackHeaderName = '';
            self.callbackHeaderValue = '';
        },
        closeCallbackHeader(){
            this.callbackHeaderValue = '';
            this.callbackHeaderName = '';
        },
        saveEditedChanges(ele){
            var self = this;
            var contentType = '';
            var serviceName = '';
            if(ele == 'notification'){
                contentType = 'notificationConfiguration';
                serviceName = 'notification';
                let formData = new FormData();
                formData.append('json', JSON.stringify({ 'apptoken': self.apptoken,
                'callback_url':self.editableCongiguration.url,
                'certificate':self.editableCongiguration.certificate,
                'action':'update',
                'config_type':contentType,
                'service_name':serviceName,
                'headers':self.tablesConfiguration.headers,
                'node':self.nodeValue}));
                showLoadIcon();
                this.$loading(true);
                Vue.http.post('/configuration/',formData)
                .then((res)=>{
                        try{
                            window.setTimeout( function(){
                                self.configurationAPI(self.tokenInConfiguration,'edit');
                            },1000);
                            self.callbackHeaderName = '';
                            self.callbackHeaderValue = '';
                            self.isEditable = false;
                            self.editableButton = true;
                            self.listOfConfigurationKeys = [];
                        }
                        catch(err){
                            console.log("error is:",err);
                        }
                        finally{
                            self.hide = hideLoadIcon();
                            if(!self.hide){
                                this.$loading(false);
                            }
                        }
                    },(error)=>{
                        self.hide = hideLoadIcon();
                        if(!self.hide){
                            this.$loading(false);
                        }
                        self.displaySnackbar('error-banner',error.data.message);
                    })
            }
            else {
                if(self.counter == 0){
                    contentType = 'global';
                    serviceName = 'global';
                }else{
                    contentType = self.configTypePopup;
                    serviceName = self.configServiceName;
                }
                self.showErrorMessage = false;
                let formData = new FormData();
                formData.append('json', JSON.stringify({ 'apptoken': self.apptoken,
                'action':'update',
                'config_type':contentType,
                'service_name':serviceName,
                'config': self.editConfigInPopupTrue.edited,
                'node':self.nodeValue
                }));
                showLoadIcon();
                this.$loading(true);
                Vue.http.post('/advanced_configuration/',formData)
                .then((res)=>{
                        try{
                            if(res.status != 200){
                                self.showErrorMessage = true;
                                self.errorMessage = 'Invalid Details/Configuration';
                            }
                            self.openPopUPLinkIsClicked('advance');
                            self.configResponse = JSON.parse(self.editConfigInPopupTrue.edited);
                            self.callbackHeaderName = '';
                            self.callbackHeaderValue = '';
                            self.isEditable = false;
                            self.editableButton = true;
                            self.editInPopupConfig = false;
                        }
                        catch(err){
                            console.log("error is:",err);
                        }
                        finally{
                            self.hide = hideLoadIcon();
                            if(!self.hide){
                                this.$loading(false);
                            }
                        }
                    },(error)=>{
                        self.hide = hideLoadIcon();
                        if(!self.hide){
                            this.$loading(false);
                        }
                        self.showErrorMessage = true;
                        self.errorMessage = error.data && error.data.message ? error.data.message : 'Invalid Details/Configuration';
                        setTimeout(function(){
                            self.showErrorMessage = false;
                        },2000);
                    })
                // advanced editor
            }
        },
        cancelPOPupEdit(){
            var self = this;
            self.editConfigInPopupTrue = {};
            self.editInPopupConfig = false;
        },
        cancelEditedConfiguration(){
            var self = this;
            self.isEditable = false;
            self.editableButton = true;
            self.validateURLStatus = null;
            self.editableCongiguration = {};
        },
        editConfig(){
            var self = this;
            self.showPanelForServicesAction = false;
            self.editInPopupConfig = true;
            self.disableSaveButton = false;
            self.editConfigInPopupTrue ={
                'edited' : JSON.stringify(self.configResponse,undefined, 8)
            }
        },
        backToConfiguration(){
            var self = this;
            self.displayPanelName = 'configuration';
            self.showPanelForServicesAction = false;
            self.showFailedListOfServices = false;
            self.selectedServiceName = 'global';
            self.openPopUPLinkIsClicked();
        },
        enableServicesForApp(){
            var self = this;
            self.displayPanelName = "services";
            self.showPanelForServicesAction = true;
            self.gotAPIResponse = false;
            showLoadIcon();
            this.$loading(true);
            Vue.http.get('/services_diff/',{
                params:{
                    'apptoken' : self.apptoken,
                    'node':self.nodeValue,
                }
            })
            .then((response)=>{
                try{
                    self.gotAPIResponse = true;
                    self.disableSaveButton = true;
                    self.configurationResponse = response.data;
                    sessionStorage.setItem('enabled_Services', JSON.stringify(response.data['enabled_services']));
                    sessionStorage.setItem('disabled_Services', JSON.stringify(response.data['not_enabled_services']))
                    self.notEnabledServices = self.configurationResponse['not_enabled_services'];
                    self.enabledServices = self.configurationResponse['enabled_services'];
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.showErrorMessage = true;
                self.errorMessage = error.data && error.data.message ? error.data.message : 'Invalid Details/Configuration';
                self.gotAPIResponse = true;
                setTimeout(function(){
                    self.showErrorMessage = false;
                },2000);
            });
        },
        closeConfig(){
            var self = this;
            self.showConfig = false;
            self.showPanelForServicesAction = false;
            self.counter = 0;
            self.showFailurePanel = false;
            self.showFailedListOfServices = false;
            self.selectedServiceName = 'global';
        },
        addServiceToSelectedList(){
            var self = this;
            var select = document.getElementById('totalList').value;
            self.disableSaveButton = false;
            if(select !=""){
                this.enabledServices.push(select);
                var del = this.notEnabledServices.indexOf(select);
                if(del == '-1'){
                    this.notEnabledServices.splice(0,1)
                }
                else{
                    this.notEnabledServices.splice(del,1);
                }
            }
        },
        removeServiceFromSelectedList(){
            var self = this;
            var select = document.getElementById('selectedList').value;
            self.disableSaveButton = false;
            if(select !=""){
                this.notEnabledServices.push(select);
                var del = this.enabledServices.indexOf(select);
                this.enabledServices.splice(del,1);
            }
        },
        showFailedList(){
            var self = this;
            self.showFailedListOfServices = !self.showFailedListOfServices;
        },
        saveSelectedServicesList(status){
            var self = this;
            self.showFailurePanel = false;
            self.showFailedListOfServices = false;
            var enabledServicesList = sessionStorage.getItem('enabled_Services');
            var enableServicesTotalList = JSON.parse(enabledServicesList);
            var disabledServicesList = sessionStorage.getItem('disabled_Services');
            var disabledServicesTotalList = JSON.parse(disabledServicesList);
            var scaledEnableList = [];
            var scaledDisabledList = [];
            for(var i = 0 ; i<= self.enabledServices.length;i++){
                if(enableServicesTotalList.includes(self.enabledServices[i]) == false && self.enabledServices[i] != undefined){
                    scaledEnableList.push(self.enabledServices[i]);
                }
            }
            for(var j = 0;j<= self.notEnabledServices.length;j++){
                if(disabledServicesTotalList.includes(self.notEnabledServices[j]) == false && self.notEnabledServices[j] != undefined){
                    scaledDisabledList.push(self.notEnabledServices[j]);
                }
            }
            if(status == 'save'){
                let formData = new FormData();
                    formData.append('json', JSON.stringify({ 'apptoken': self.apptoken,
                        'action':'save',
                        'enabled_services':scaledEnableList,
                        'disabled_services':scaledDisabledList,
                        'node':self.nodeValue
                    }));
                self.gotAPIResponse = false;
                showLoadIcon();
                this.$loading(true);
                Vue.http.post('/apptoken_services/',formData)
                .then((res)=>{
                        try{
                            self.gotAPIResponse = true;
                            self.disableSaveButton = true;
                            self.enableServicesForApp();
                            if(res.data.failed_services){
                                if(Object.keys(res.data.failed_services).length != 0){
                                    self.failureList1 = Object.keys(res.data.failed_services);
                                }
                                self.showFailurePanel = true;
                            }
                        }
                        catch(err){
                            console.log("error is:",err);
                        }
                        finally{
                            self.hide = hideLoadIcon();
                            if(!self.hide){
                                this.$loading(false);
                            }
                        }
                    },(error)=>{
                        self.hide = hideLoadIcon();
                        if(!self.hide){
                            this.$loading(false);
                        }
                        // console.log("error");
                        self.gotAPIResponse = true;
                        self.displaySnackbar('error-banner',error.data.message);
                    })
            }
            else{
                self.showPanelForServicesAction = true;
                self.notEnabledServices = disabledServicesTotalList;
                self.enabledServices = enableServicesTotalList;
                self.disableSaveButton = true;
            }
        },
        hideLoadIcon,
        showLoadIcon
    }
}
</script>
